

import React from 'react';

import vtemp1 from '../../assets/biodata/view-temp/biodata-1.png';
import vtemp2 from '../../assets/biodata/view-temp/biodata-2.png';
import vtemp3 from '../../assets/biodata/view-temp/biodata-4.png';
import vtemp4 from '../../assets/biodata/view-temp/biodata-5.png';
import vtemp5 from '../../assets/biodata/view-temp/biodata-6.png';
import vtemp6 from '../../assets/biodata/view-temp/biodata-7.png';
import vtemp11 from '../../assets/biodata/view-temp/biodata-11.png';
import vtemp12 from '../../assets/biodata/view-temp/biodata-12.png';

function Biofooter() {
  return (<>
      <div class="bd_landing_sect3  mb-4 bg-white p-3 mt-4 mb-4 rounded-lg shadow-sm">
        <h2 className="bd_l_title">Who Can Use This Marriage Biodata Maker?</h2>
        <div class="use-grid">
          <div class="use-card">👦 Boys looking for marriage biodata</div>
          <div class="use-card">👧 Girls marriage biodata</div>
          <div class="use-card">👨‍👩‍👧 Parents creating biodata for children</div>
          <div class="use-card">🕉️ Hindu marriage biodata format</div>
        </div>
      </div>

      <div className="bd_landing_sect3  mb-4 bg-white p-3 mt-4 mb-4 rounded-lg shadow-sm">
            <h3 className="bd_l_title">Sample Marriage Biodata Format</h3>
            <p className="text-center">Below is a sample marriage biodata created using our free tool. 
You can customize every section as per your requirement.</p>
            <div className="bd_template_slider">
              <div className="biodata_sample"><img src={vtemp11}/></div>
              <div className="biodata_sample"><img src={vtemp12}/></div>
              <div className="biodata_sample"><img src={vtemp1}/></div>
              <div className="biodata_sample"><img src={vtemp2}/></div>
              <div className="biodata_sample"><img src={vtemp3}/></div>
              <div className="biodata_sample"><img src={vtemp4}/></div>
              <div className="biodata_sample"><img src={vtemp5}/></div>
              <div className="biodata_sample"><img src={vtemp6}/></div>
            </div>

      </div>

      <div className="bd_landing_sect3  mb-4 bg-white p-3 mt-4 mb-4 rounded-lg shadow-sm">
         <h3 className="bd_l_title">Frequently Asked Questions</h3>

        <details className="faq_panel" open>
          <summary>What is a marriage biodata maker?</summary>
          <p className="selectionShareable">A marriage biodata maker is a free online tool that helps you create a professional marriage biodata and download it in PDF or image format.</p>
        </details>

        <details className="faq_panel">
          <summary>Is there any fee for creating a biodata?</summary>
          <p className="selectionShareable">No, this online marriage biodata maker is completely free to use with no hidden charges.</p>
        </details>


        <details className="faq_panel">
          <summary>Do I need to create an account to make the biodata?</summary>
          <p className="selectionShareable">No account is required. You can directly enter your details and create your marriage biodata online without signing up.</p>
        </details>

        <details className="faq_panel">
          <summary>How many types of templates are available?</summary>
          <p className="selectionShareable">Multiple professionally designed marriage biodata templates are available, allowing you to choose a layout that matches your preference.</p>
        </details>

        <details className="faq_panel">
          <summary>Can I create more than one biodata?</summary>
          <p className="selectionShareable">Yes, you can create and download unlimited marriage biodatas using this tool.</p>
        </details>

        <details className="faq_panel">
          <summary>How do I download the biodata?</summary>
          <p className="selectionShareable">After completing your biodata, simply click the download button to save it as a PDF or image file.</p>
        </details>

        <details className="faq_panel">
          <summary>Can the biodata be downloaded in formats other than PDF?</summary>
          <p className="selectionShareable">Yes, along with PDF, you can also download your marriage biodata in image (PNG) format.</p>
        </details>

        <details className="faq_panel">
          <summary>I accidentally downloaded the biodata, can I create it again?</summary>
          <p className="selectionShareable">Yes, you can edit your information anytime and generate a new biodata with updated details.</p>
        </details>

        <details className="faq_panel">
          <summary>Is my information secure on your website?</summary>
          <p className="selectionShareable">Yes, your information is secure. The data you enter is not shared with any third party.</p>
        </details>

        <details className="faq_panel">
          <summary>Can I create the biodata in any language?</summary>
          <p className="selectionShareable">Yes, the marriage biodata maker supports multiple Indian languages including Hindi, English, Marathi, Gujarati, Tamil, Telugu, Kannada, and Malayalam</p>
        </details>

        <details className="faq_panel">
          <summary>Can I preview the design of the biodata?</summary>
          <p className="selectionShareable">Yes, you can preview the biodata design before downloading to ensure it looks exactly as you want.</p>
        </details>

        <details className="faq_panel">
          <summary>Can the biodata have multiple pages?</summary>
          <p className="selectionShareable">Yes, if your content is long, the biodata will automatically generate multiple pages.</p>
        </details>
        
        <details className="faq_panel">
          <summary> Is there a limit to how much information I can include in the biodata?</summary>
          <p className="selectionShareable">No, there is no fixed limit. You can include as much information as needed while keeping the layout clean and readable.</p>
        </details>
    </div></>
  )
}
export default Biofooter
